import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Authenticate from './pages/Authenticate';
import Callback from './pages/Callback';
import Umoor from './pages/Committees/12Umoor';
import Tadfeen from './pages/Committees/Tadfeen';
import UmoorSehat from './pages/Resources/UmoorSehat';
import Calendar from './pages/Resources/Calendar';
import JamaatOffice from './pages/Resources/JamaatOffice';
import QardanHasanahResource from './pages/Resources/QardanHasanah';
import BusinessListings from './pages/Resources/BusinessListings';
import Ziyarat from './pages/Resources/Ziyarat';
import Cemetery from './pages/Resources/Cemetery';
import Masool from './pages/Masool';
import Directory from './pages/Resources/Directory';
import Ashara1448RelayCenter from './pages/Resources/Ashara1448RelayCenter';
import AnjumanCommittee from './pages/Committees/AnjumanCommittee';
import AdvisoryCommittee from './pages/Committees/AdvisoryCommittee';

import Privacy from './pages/privacy';
import Terms from './pages/terms';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />

        <Routes>
          {/* Public routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/authenticate" element={<Authenticate />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/jamaat/12umoor" element={<Umoor />} />
              <Route path="/jamaat/anjuman" element={<AnjumanCommittee />} />
              <Route path="/jamaat/advisory" element={<AdvisoryCommittee />} />

              <Route path="/resources/jamaat-office" element={<JamaatOffice />} />
              <Route path="/resources/calendar" element={<Calendar />} />
              <Route path="/resources/qardan-hasanah" element={<QardanHasanahResource />} />
              <Route path="/resources/business-listings" element={<BusinessListings />} />
              <Route path="/resources/ziyarat" element={<Ziyarat />} />
              <Route path="/resources/cemetery" element={<Cemetery />} />
              <Route path="/resources/UmoorSehat" element={<UmoorSehat />} />
              <Route path="/resources/directory" element={<Directory />} />
              <Route path="/resources/ashara1448relaycenter" element={<Ashara1448RelayCenter />} />
              <Route path="/committees/tadfeen" element={<Tadfeen />} />

              <Route path="/masool" element={<Masool />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;